<template>
  <jr-button type="primary" size="small" @click="exportPrint">出力</jr-button>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import JrButton from '@/components/jr-parts/JrButton.vue'
import { ElForm } from 'element-plus'
import { AnswerPrintCreate } from '@/requests/answerPrint'
import { download, createBase64Str } from '@/services/file'
import { AnswerPrintRequest, AnswerPrintResponse } from '@/api'
import { AxiosResponse } from 'axios'
import { RequestHeaderProximityForm } from '@/types/forms'

export default defineComponent({
  name: 'AnswerPrintExport',
  components: {
    JrButton,
  },
  props: {
    //回答項目ID
    answerDraftItems: {
      type: Array as PropType<number[]>,
      required: true,
    },
    proximity: {
      type: Object as PropType<RequestHeaderProximityForm>,
      required: true,
    },
    //回答相手略称
    answerApplicantAbbreviation: {
      type: String,
      required: true,
    },
    formRef: {
      type: Object as PropType<InstanceType<typeof ElForm>>,
      required: false,
      default: null,
    },
    //回答案タイトル
    answerDraftTitle: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const exportPrint = () => {
      if (!props.formRef) {
        return
      }

      props.formRef.validate(async (valid) => {
        if (!valid) {
          return false
        } else {
          const requestData: AnswerPrintRequest = {
            answer_draft_title: props.answerDraftTitle,
            answer_applicant_abbreviation: props.answerApplicantAbbreviation,
            answer_draft_items: props.answerDraftItems,
            request_header_id: props.proximity.request_header_id as number,
          }

          //回答案印刷API呼び出し
          const request = new AnswerPrintCreate(requestData)
          await request.exec()
          if (request.success) {
            //ファイルのバイナリデータを取得
            const { data } = request.getResponse() as AxiosResponse<AnswerPrintResponse>
            //ファイルデータ
            const base64 = createBase64Str(data.mime_type as string, data.file as string)
            //ファイル名
            const fileName = `${props.proximity.applicant_number}（回答案）`
            download(base64, fileName, data.mime_type as string)
          }
        }
      })
    }
    return {
      exportPrint,
    }
  },
})
</script>
